module.exports = (SalonService, RESTService) ->
  'ngInject'
  {
    service: (salonId) ->
      RESTService.setFullResponse(true).one('admin/salons', salonId).one('clients')
  }
